import type { ReactNode } from "react";
import { cx } from "@/utils/cx";

interface TabContentWrapperProps {
	/** Unique key for the current tab - triggers animation when changed */
	tabKey: string;
	/** Content to render */
	children: ReactNode;
	/** Additional CSS classes */
	className?: string;
}

/**
 * TabContentWrapper
 *
 * Provides fade animation for tab content changes using pure CSS.
 * Matches the view transition fade timing (600ms) using Tailwind's animation utilities.
 * The key prop forces React to unmount/remount, triggering the fade-in animation.
 */
export function TabContentWrapper({
	tabKey,
	children,
	className,
}: TabContentWrapperProps) {
	return (
		<div
			key={tabKey}
			className={cx(
				// Fade in animation - 600ms to match view transitions
				"animate-in fade-in duration-600",
				className,
			)}
		>
			{children}
		</div>
	);
}
